import * as React from 'react';
import { useState } from 'react';
import {PrimaryButton, TextButton, CloseIcon} from '@liveoptics/react-ui';
import styled from '@emotion/styled';
import '../css/modal-helpers.css';
import ExclamationCircleIcon from '../svgs/ExclamationCircleIcon';
import CloudCalcBaseModal from './CloudCalcBaseModal';

const ModalInnerWrap = styled.div`
    padding: 2rem;
`;

const ModalActionWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    margin-top: 25px;
`;

const ModalActionInner = styled.div`
    margin-right: 1rem;
`;

const CreateNewSessionModal = ({createNewFunction, closeFunction}) => {
    let icon = (<ExclamationCircleIcon fill="#F2AF00" />);

    return (
        <CloudCalcBaseModal modalTitle="Create New" modalIcon={icon} closeFn={closeFunction}>
            <ModalInnerWrap>
                <div>
                    To create new estimates, your current inputs will be deleted. Are you sure you want to proceed?
                </div>
                
                <ModalActionWrap>
                    <ModalActionInner>
                        <TextButton clickFn={() => {createNewFunction();}}>Yes, Create New</TextButton>
                    </ModalActionInner>
                    <PrimaryButton clickFn={closeFunction}>Cancel</PrimaryButton>
                </ModalActionWrap>
            </ModalInnerWrap>
        </CloudCalcBaseModal>
    );
}

export default CreateNewSessionModal;